module.exports = __webpack_public_path__ + "static/media/tiny6.0efdf218.png";